// The usage figures quoted as social proof. ONE place, because they appear on
// more than one screen (the landing strip and the ad-click hook) and two copies
// of a marketing number drift the first time someone updates only the one they
// are looking at. Hand-maintained: bump these when the real counts move.

export const USAGE_STATS = {
  scans: 8800,
  users: 3400,
} as const;

/** `8800` -> `8.8k`. Below a thousand the figure is shown whole. */
export function formatUsageFigure(n: number): string {
  const r = Math.round(n);
  return r < 1000 ? String(r) : `${(r / 1000).toFixed(1)}k`;
}
